module.exports = __webpack_public_path__ + "static/img/add.397f9f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/image/add.png
// module id = eLXq
// module chunks = 1